<template>
  <div class="rescueActivity">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <el-col :span="12"
            ><el-button size="small" icon="el-icon-plus" @click="add"
              >新增</el-button
            ></el-col
          >
          <el-col :span="12">
            <div class="search-box">
              <el-input
                style="width: 290px;margin-right: 10px;"
                clearable
                v-model="request.searchKey"
                placeholder="关键字"
              />
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="loadData(1)"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table
        :data="list"
        v-loading="loading"
        style="width: 100%"
        border
        :max-height="tableMaxHeight()"
      >
        <el-table-column
          prop="ActivityName"
          label="救援活动名称"
          show-overflow-tooltip
        />
        <el-table-column label="活动时间" width="150">
          <template slot-scope="scope">
            {{ (scope.row.ActivityTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="Address" label="地点" show-overflow-tooltip />
        <el-table-column prop="Count" label="活动参与人数" width="120" />
        <el-table-column prop="Leader" label="负责人" width="120" />
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-access:delete
              type="text"
              size="mini"
              @click="deleted(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="request.pageSize"
          :currentPage="request.pageIndex"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
      </div>
    </BasePage>
    <el-dialog
      el-dialog
      title="救援活动详情"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="editContent">
        <el-form
          :model="form"
          ref="form"
          :rules="rules"
          label-width="120px"
          label-position="right"
        >
          <el-form-item label="救援活动名称：" prop="ActivityName">
            <el-input
              v-model="form.ActivityName"
              maxlength="100"
              placeholder="请输入救援活动名称"
              style="width: 60%"
            />
          </el-form-item>
          <el-form-item label="活动时间：" prop="ActivityTime">
            <el-date-picker
              v-model="form.ActivityTime"
              type="datetime"
              placeholder="活动时间"
              style="width: 60%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="地点：" prop="Address">
            <el-input
              v-model="form.Address"
              maxlength="100"
              placeholder="请输入地点"
              style="width: 60%"
            />
          </el-form-item>
          <el-form-item label="活动参与人数：" prop="Count">
            <el-input
              v-model="form.Count"
              type="Number"
              placeholder="请输入活动参与人数"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              style="width: 60%"
            />
          </el-form-item>
          <el-form-item label="负责人：" prop="Leader">
            <el-input
              v-model="form.Leader"
              maxlength="20"
              placeholder="请输入负责人"
              style="width: 60%"
            />
          </el-form-item>
          <el-form-item label="备注：" prop="Remark">
            <el-input
              v-model="form.Remark"
              type="textarea"
              :rows="3"
              maxlength="200"
              show-word-limit
              placeholder="请输入备注"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="btnLoading"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import api from "@/modules/zjrc/api";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
export default {
  name: "rescueActivity",
  components: {
    BasePage,
    OfPagination,
  },
  data() {
    return {
      request: {
        pageIndex: 1,
        pageSize: 15,
        searchKey: "",
      },
      list: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      form: {},
      rules: {
        ActivityName: {
          required: true,
          message: "请输入救援活动名称",
          trigger: "blur",
        },
        ActivityTime: {
          required: true,
          message: "请选择活动时间",
          trigger: "blur",
        },
        Address: { required: true, message: "请输入地点", trigger: "blur" },
        Leader: { required: true, message: "请输入负责人", trigger: "blur" },
        Count: { required: true, message: "请输入参与人数", trigger: "blur" },
      },
      btnLoading: false,
    };
  },
  mounted() {
    const vm = this;
    vm.loadData(1);
  },
  methods: {
    deleted(row) {
      const vm = this;
      vm.$confirm("确定删除选中救援活动?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.loading = true;
        const param = { id: row.Id };
        api.DeleteRescueActivityById(param).then((res) => {
          if (res.data.Code === 0) {
            vm.$message({
              message: "保存成功",
              type: "success",
            });
            vm.loadData(1);
          }
        });
      });
    },
    edit(row) {
      const vm = this;
      vm.form = Object.assign({}, row);
      vm.form.ActivityTime = vm.form.ActivityTime * 1000;
      vm.dialogVisible = true;
    },
    onSubmit() {
      const vm = this;
      vm.$refs.form.validate((valid) => {
        if (valid) {
          vm.btnLoading = true;
          let param = Object.assign({}, vm.form);
          param.ActivityTime = param.ActivityTime / 1000;
          api.SaveRescueActivity(param).then((res) => {
            if (res.data.Code === 0) {
              vm.$message({
                message: "保存成功",
                type: "success",
              });
            }
            vm.loadData(1);
            vm.dialogVisible = false;
            vm.btnLoading = false;
          });
        }
      });
    },
    add() {
      const vm = this;
      vm.form = {};
      vm.dialogVisible = true;
    },
    loadData(pageIndex) {
      const vm = this;
      vm.request.pageIndex = pageIndex;
      vm.loading = true;
      api.QueryRescueActivity(vm.request).then((res) => {
        if (res.data.Code === 0) {
          vm.total = res.data.Data.total;
          vm.list = res.data.Data.rows;
        }
        vm.loading = false;
      });
    },
    handleCurrentChange(pageIndex) {
      const vm = this;
      if (vm.total > vm.request.pageSize) {
        vm.loadData(pageIndex);
      }
    },
    handleSizeChange(pageSize) {
      const vm = this;
      vm.request.pageSize = pageSize;
      vm.loadData(1);
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.rescueActivity {
  .search-box {
    text-align: right;
    .toolBar-search {
      width: 300px;
      padding-right: 20px;
    }
  }
  .editContent {
    max-height: 80vh;
    overflow-y: auto;

    .datePicker {
      padding: 0 !important;
    }
  }
}
</style>